import React from "react";
import { Radio, RadioGroup} from 'rsuite';

import './radioContent.scss';
const  RadioContent= ({name, style,type,options,getAnswerValueByName,updateAnswer,defaultValue}) => {

    return (
        <div className={`${style?style:''}`}>
            <RadioGroup
                name={name}
                value={getAnswerValueByName(name) ? getAnswerValueByName(name) : defaultValue?.toString()}
                onChange={(value, event) => updateAnswer(event, type)}
                className={style}>
                {options.map((option, optionIndex) => {
                    return <div key={optionIndex}>
                        <Radio className="d-block"
                               value={option.id.toString()}
                               key={optionIndex}
                               defaultChecked={option.id.toString() === defaultValue?.toString()}
                        >
                            <div className="option-title">
                                {option?.icon ? <img className="ml-1" src={option?.icon}/> : ''}
                                {option?.title}
                            </div>
                            <div className="option-content">{option?.content}</div>
                        </Radio>
                    </div>;
                })}
            </RadioGroup>
        </div>
    );



}

export default RadioContent;